export function isValidIdentity(ownerId) {
    return ![null, "undefined"].includes(ownerId);
}